export default () => {
    const passwordToggle = document.querySelector('.js-form-toggle-password');
    const form = passwordToggle ? passwordToggle.closest('.js-form') : null;
    const passwordField = form ? form.querySelector('input[type="password"]') : null;

    if (!passwordToggle || !form || !passwordField) {
        return;
    }

    passwordToggle.addEventListener('click', () => {
        if (passwordField.getAttribute('type') === 'password') {
            passwordField.setAttribute('type', 'text');
        } else {
            passwordField.setAttribute('type', 'password');
        }
    });
};
